import { Injectable } from '@angular/core';
import { CUSTOMER_TYPE, EMAIL_POPUP, ICON_PATH_KEY } from '@app/core/constants/app.enum';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../alert/alert.service';
import { SharedService } from '../shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class AppHelperService {
  constructor(
    private sharedSvc: SharedService,
    private translateService: TranslateService,
    private alertSvc: AlertService,
    private navCtrl: NavController
  ) {}

  icon(file, key: ICON_PATH_KEY): string {
    if (
      (key !== ICON_PATH_KEY.folder && file[key] === 'folder') ||
      (key === ICON_PATH_KEY.folder && file.folder)
    ) {
      return '/assets/icon/folder.svg';
    }
    const fileExt = file.name.split('.').pop();
    switch (fileExt.toLowerCase()) {
      case 'zip':
        return '/assets/icon/png-icons/zip.png';
      case 'heic':
        return '/assets/icon/png-icons/heic.png';
      case 'xps':
        return '/assets/icon/png-icons/xps.png';
      case 'xlsx':
        return '/assets/icon/png-icons/xlsx.png';
      case 'xls':
        return '/assets/icon/png-icons/xls.png';
      case 'txt':
        return '/assets/icon/png-icons/txt.png';
      case 'tiff':
        return '/assets/icon/png-icons/tiff.png';
      case 'tif':
        return '/assets/icon/png-icons/tif.png';
      case 'rtf':
        return '/assets/icon/png-icons/rtf.png';
      case 'pptx':
        return '/assets/icon/png-icons/pptx.png';
      case 'ppt':
        return '/assets/icon/png-icons/ppt.png';
      case 'png':
        return '/assets/icon/png-icons/png.png';
      case 'pdf':
        return '/assets/icon/png-icons/pdf.png';
      case 'odt':
        return '/assets/icon/png-icons/odt.png';
      case 'ods':
        return '/assets/icon/png-icons/ods.png';
      case 'odp':
        return '/assets/icon/png-icons/odp.png';
      case 'jpg':
        return '/assets/icon/png-icons/jpg.png';
      case 'jpeg':
        return '/assets/icon/png-icons/jpeg.png';
      case 'html':
        return '/assets/icon/png-icons/html.png';
      case 'htm':
        return '/assets/icon/png-icons/htm.png';
      case 'gif':
        return '/assets/icon/png-icons/gif.png';
      case 'docx':
        return '/assets/icon/png-icons/docx.png';
      case 'doc':
        return '/assets/icon/png-icons/doc.png';
      case 'bmp':
        return '/assets/icon/png-icons/bmp.png';
      default:
        return '/assets/icon/png-icons/default-file.png';
    }
  }

  async emailPopup(val: EMAIL_POPUP) {
    const customerDetails = this.sharedSvc.getCustomerDetails;
  
    if (customerDetails) {
      const { HowToLogoSection: howLogoSection } = customerDetails.customizationsText;
      const { CustomerType } = customerDetails.customerData;
  
      let bwEmail = '';
      let colorEmail = '';
      let email = '';
      let aliasEmail = '';
  
      if (CustomerType === CUSTOMER_TYPE.tbs) {
        bwEmail = howLogoSection.EmailAddressAssignedGrayscaleAlias || howLogoSection.EmailAddressAssignedGrayscale;
        colorEmail = howLogoSection.EmailAddressAssignedColorAlias || howLogoSection.EmailAddressAssignedColor;
      } else {
        email = howLogoSection.EmailAddressAssignedCustomer;
        aliasEmail = howLogoSection.EmailAddressAssignedCustomerAlias;
        val = aliasEmail ? EMAIL_POPUP.nonTbsAliasEmailPrinting : EMAIL_POPUP.nonTbsEmailPrinting;
      }
  
      const createEmailContent = (header: string, content: string) =>
        `${this.translateService.instant('OTHER_EMAIL_STARTING_STRING')}:
         <br><br>${header}: 
         <a href="mailto:${content}" class="text-blue-700">${content}</a>
         <br><br>${this.translateService.instant('OTHER_EMAIL_SUB_STRING')}`;
  
      switch (val) {
        case EMAIL_POPUP.emailPrinting:
          this.alertSvc.emailAlert(
            `${this.translateService.instant('OTHER_EMAIL_STARTING_STRING')}:
             <br><br>B&W ${this.translateService.instant('PRINTER')}: 
             <a href="mailto:${bwEmail}" class="text-blue-700">${bwEmail}</a>
             <br><br>${this.translateService.instant('COLOR_PRINTER')}: 
             <a href="mailto:${colorEmail}" class="text-blue-700">${colorEmail}</a>
             <br><br>${this.translateService.instant('OTHER_EMAIL_SUB_STRING')}`
          );
          break;
        case EMAIL_POPUP.nonTbsEmailPrinting:
          this.alertSvc.emailAlert(createEmailContent('Email', email));
          break;
        case EMAIL_POPUP.nonTbsAliasEmailPrinting:
          this.alertSvc.emailAlert(createEmailContent('Alias Email', aliasEmail));
          break;
        default:
          break;
      }
    } else {
      if (await this.alertSvc.emailPrintingAlert()) {
        this.navCtrl.navigateForward('app/add-files/maps', { state: { showMenu: false } });
      }
    }
  }
}
